import React from "react";
import Currency from "./Currency";

const DebugInfo = ({ ticketData, formatDate, textColor }) => {
  if (!ticketData || !ticketData.resource) return null;

  return (
    <div data-testid="debug-info">
      <div className="mb-6 p-4 rounded bg-blue-50 border border-blue-200">
        <h3 className="text-lg font-semibold mb-2" style={{ color: textColor }}>
          Ticket Information
        </h3>
        <div className="grid grid-cols-2 gap-2">
          <div className="text-sm text-gray-600">Ticket ID:</div>
          <div className="text-sm font-medium">{ticketData.resource.uuid}</div>

          <div className="text-sm text-gray-600">Status:</div>
          <div className="text-sm font-medium">
            {ticketData.resource.status === 0 ? (
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                Pending
              </span>
            ) : ticketData.resource.status === 1 ? (
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                Completed
              </span>
            ) : (
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                Unknown
              </span>
            )}
          </div>

          <div className="text-sm text-gray-600">Tax Exempt:</div>
          <div className="text-sm font-medium">
            {ticketData.resource.tax_exempt ? "Yes" : "No"}
          </div>
        </div>
      </div>

      {ticketData.resource.payment_items &&
        ticketData.resource.payment_items.length > 0 && (
          <div className="mb-6">
            <h3
              className="text-lg font-semibold mb-2"
              style={{ color: textColor }}
            >
              Payment Information
            </h3>
            {ticketData.resource.payment_items.map((item, index) => (
              <div
                key={index}
                className="mb-4 p-4 rounded bg-gray-50 border border-gray-200"
              >
                {item.payment && (
                  <div className="grid grid-cols-2 gap-2">
                    <div className="text-sm text-gray-600">Payment ID:</div>
                    <div className="text-sm font-medium">{item.payment.id}</div>

                    <div className="text-sm text-gray-600">Transaction ID:</div>
                    <div className="text-sm font-medium">
                      {item.payment.transaction_id}
                    </div>

                    <div className="text-sm text-gray-600">Amount:</div>
                    <div className="text-sm font-medium">
                      <Currency value={item.payment.amount} />
                    </div>

                    <div className="text-sm text-gray-600">Status:</div>
                    <div className="text-sm font-medium">
                      <span
                        className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                          item.payment.status === "completed"
                            ? "bg-green-100 text-green-800"
                            : item.payment.status === "pending_capture"
                            ? "bg-yellow-100 text-yellow-800"
                            : "bg-gray-100 text-gray-800"
                        }`}
                      >
                        {item.payment.status.replace("_", " ")}
                      </span>
                    </div>

                    {item.payment.data && item.payment.data.brand && (
                      <>
                        <div className="text-sm text-gray-600">Card Type:</div>
                        <div className="text-sm font-medium capitalize">
                          {item.payment.data.brand}
                        </div>

                        <div className="text-sm text-gray-600">
                          Last 4 Digits:
                        </div>
                        <div className="text-sm font-medium">
                          {item.payment.data.last4}
                        </div>
                      </>
                    )}

                    <div className="text-sm text-gray-600">Created At:</div>
                    <div className="text-sm font-medium">
                      {formatDate(item.payment.created_at)}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
    </div>
  );
};

export default DebugInfo;
